import { Space, Card, Row, Col, Typography, Grid } from '@Shared/ui';
import { Breadcrumbs, PageContent, type BreadcrumbItemType } from '@Features/shared';
import { LegalInfoForm } from '@Features/publisher/legalInfo';
// import './styles.scss';

const { Title, Link } = Typography;
const { useBreakpoint } = Grid;

const pageBreadcrumbs: BreadcrumbItemType[] = [
    {
        path: '/legal-info',
        title: 'Юридические данные',
    },
];

const LegalInfoPage = () => {
    const breakpoints = useBreakpoint();

    return (
        <PageContent>
            <Breadcrumbs items={pageBreadcrumbs} />
            <Row
                gutter={[10, 10]}
                style={{
                    rowGap: breakpoints.md ? 10 : 0,
                    flexDirection: breakpoints.lg ? 'row' : 'column',
                    flexWrap: breakpoints.lg ? 'nowrap' : 'wrap',
                }}
            >
                <Col flex="auto">
                    <LegalInfoForm />
                </Col>
                <Col style={{ flex: breakpoints.lg ? '320px 0 0' : 'auto' }}>
                    <Card style={{ width: '100%', background: '#fff' }}>
                        <Space
                            direction="vertical"
                            size="middle"
                        >
                            <Title
                                type="secondary"
                                level={3}
                            >
                                FAQ
                            </Title>
                            <Link
                                href="https://support.mitgo.com/ru/knowledge-base/article/%D0%B4%D0%BB%D1%8F-%D1%87%D0%B5%D0%B3%D0%BE-%D0%BF%D0%B0%D0%B1%D0%BB%D0%B8%D1%88%D0%B5%D1%80%D1%83-%D0%BD%D1%83%D0%B6%D0%BD%D0%BE-%D1%83%D0%BA%D0%B0%D0%B7%D1%8B%D0%B2%D0%B0%D1%82%D1%8C-%D1%8E%D1%80%D0%B8%D0%B4%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B5-%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D0%B5"
                                target="_blank"
                            >
                                Для чего указывать юридические данные?
                            </Link>
                            <Link
                                href="https://support.mitgo.com/ru/knowledge-base/article/%D0%BA%D0%B0%D0%BA-%D0%BC%D0%B0%D1%80%D0%BA%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D1%82%D1%8C-%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D1%83"
                                target="_blank"
                            >
                                Как маркировать рекламу?
                            </Link>
                            <Link
                                onClick={() => {
                                    window.location.href = `mailto:${process.env.SUPPORT_EMAIL}`;
                                }}
                            >
                                Нужна помощь?
                            </Link>
                        </Space>
                    </Card>
                </Col>
            </Row>
        </PageContent>
    );
};
export default LegalInfoPage;
